import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';
import { AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage } from '@angular/fire/storage';

import { async } from '@angular/core/testing';
import { MatSelect } from '@angular/material/select';
import { Policy } from 'src/app/policy.model';

@Component({
  selector: 'app-editplan',
  templateUrl: './editplan.component.html',
  styleUrls: ['./editplan.component.css']
})
export class EditplanComponent implements OnInit {

  planid:string;
  plan:any;

  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  url:string;
  categories:string[] = ['Home Broadband', 'Corporate Broadband'];
  cat:string = '';
  id2:string='';
  imgUploaded:boolean=true;

  
  exampleForm: FormGroup;
  validation_messages = {
    'pname': [
      { type: 'required', message: 'Plan Name is required.' }
    ],
    'speed': [
      { type: 'required', message: 'Speed is required.' }
    ],
    'data': [
      { type: 'required', message: 'High Speed Data is required.' }
    ],
    'exspeed': [
      { type: 'required', message: 'Exhausted Data speed is required.' }
    ],
    'price': [
      { type: 'required', message: 'Price is required.' }
    ],
    'category': [
      { type: 'required', message: 'Category is required.' },
    ]
  };

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private router: Router, private ar: ActivatedRoute,
    public firebaseService: FirebaseService,
    private afs: AngularFireStorage) { }

  ngOnInit(): void {
    this.createForm();
    this.planid= this.ar.snapshot.paramMap.get('plan');
    this.firebaseService.getPlan(this.planid).subscribe(plan =>{
      this.plan=plan;
      this.exampleForm.setValue({
        pname: this.plan.payload.data().pname,
        category: this.plan.payload.data().category,
        price: this.plan.payload.data().price,
        speed: this.plan.payload.data().speed,
        exspeed: this.plan.payload.data().exspeed,
        data: this.plan.payload.data().data,
      });
    });
  }

  editPlan(value:Policy){
    if(!this.imgUploaded){
      alert("Please let the image Upload");
    }
    else{
      this.firebaseService.updatePlan(this.planid, value);
      this.router.navigateByUrl('adminbackend/allplans');}
  }

  goAllPlans(){
    this.router.navigateByUrl('adminbackend/allplans');
  }

  createForm(){
    this.exampleForm = this.fb.group({
      pname: ['', Validators.required ],
      data:['', Validators.required ],
      speed:['', Validators.required ],
      exspeed:['', Validators.required ],
      price: ['', Validators.required ],
      category: ['', Validators.required ]
    });
  }
  

  upload(event){
    this.imgUploaded=false;
    this.id2= Math.random().toString(36).substring(2);
    this.ref=this.afs.ref(this.id2);
    this.task= this.ref.put(event.target.files[0]);
    this.task.percentageChanges().subscribe(res=>{
      if(res==100){
        this.afs.ref(this.id2).getDownloadURL().subscribe(result=>{
          this.url=result;
          this.exampleForm.patchValue({
            imgurl: result
          });
          this.plan.payload.data().imgurl=result;
          this.imgUploaded=true;
        });
      }
    });
  }
}
